<template>
    <div class="plans-wrapper">
        <div class="plans-wrapper-title">{{ $t("billing.additionalPackages") }}</div>
        <div class="plans-wrapper-content">
            <FeaturePlan
                v-for="featurePlan in getFeaturePlans()"
                :key="featurePlan._id"
                :plan="featurePlan"
                :is-selected="isSelected(featurePlan)"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import FeaturePlan from "./FeaturePlan.vue";

export default {
    name: "FeaturePlans",
    components: { FeaturePlan },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            plans: (state) => state.site.plans,
            currentPlans: (state) => state.site.currentPlans,
        }),
    },
    methods: {
        getFeaturePlans() {
           return this.plans.filter((plan) => plan.type === "feature");
        },
        isSelected(plan) {
            return this.currentPlans.some((currentPlan) => currentPlan.planId === plan._id);
        },
    },
};
</script>
<style lang="scss" scoped>
.plans-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding: 20px;

    &-title {
        font-size: 20px;
        font-weight: 600;
        color: #1C1B1F;
    }

    &-content {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        grid-gap: 10px;
        border-radius: 8px;
        box-sizing: border-box;
    }
}
</style>
